import React from 'react';
import styled from 'styled-components';
import LogoPng from '../assets/InitX_Logo.png';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const LogoImage = styled.img`
  height: ${props => props.size || '40px'};
  width: auto;
  object-fit: contain;
  transition: all 0.3s ease;
`;

const LogoText = styled.span`
  font-size: ${props => props.textSize || '1.5rem'};
  font-weight: 700;
  margin-left: 10px;
  color: ${props => props.textColor || '#333'};
  font-family: 'Inter', sans-serif;
`;

const Logo = ({ 
  size = '40px', 
  showText = true, 
  textColor = '#333',
  textSize = '1.5rem',
  onClick,
  className 
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.location.href = '/';
    }
  };

  return (
    <LogoContainer onClick={handleClick} className={className}>
      <LogoImage 
        src={LogoPng}
        alt="InitX Technologies" 
        size={size}
      />
      {showText && (
        <LogoText textColor={textColor} textSize={textSize}>
          InitX
        </LogoText>
      )}
    </LogoContainer>
  );
};

export default Logo;